import React from 'react';
import './BrandLogo.css';

const ASSETS = {
  wordmark: {
    dark: '/brand/eliteedge-wordmark-dark.png',
    light: '/brand/eliteedge-wordmark-light.png',
  },
  icon: {
    dark: '/brand/eliteedge-icon.svg',
    light: '/brand/eliteedge-icon-light.svg',
  },
};

export default function BrandLogo({
  variant = 'wordmark',
  height = 36,
  showBeta = false,
  decorative = false,
  className = '',
  style,
}) {
  const assets = ASSETS[variant] || ASSETS.wordmark;
  const accessibleProps = decorative
    ? { 'aria-hidden': true }
    : { role: 'img', 'aria-label': 'Elite Edge AI' };

  return (
    <span
      className={`eliteedge-brand eliteedge-brand--${variant} ${className}`.trim()}
      style={{ '--eliteedge-brand-height': `${height}px`, ...style }}
      {...accessibleProps}
    >
      <span className="eliteedge-brand__art" aria-hidden="true">
        <img className="eliteedge-brand__image eliteedge-brand__image--dark" src={assets.dark} alt="" />
        <img className="eliteedge-brand__image eliteedge-brand__image--light" src={assets.light} alt="" />
      </span>
      {showBeta && <span className="eliteedge-brand__beta">BETA</span>}
    </span>
  );
}
